// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const TableActionButtonsWrapper = styled.div`
  display: flex;
  gap: 8px;
`;
